(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("create-es6-js"));
	else if(typeof define === 'function' && define.amd)
		define(["create-es6-js"], factory);
	else if(typeof exports === 'object')
		exports["evolve-js"] = factory(require("create-es6-js"));
	else
		root["evolve-js"] = factory(root["create-es6-js"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Components = exports.Elements = exports.Sound = exports.Preload = exports.Anim = exports.Draw = exports.Core = undefined;
	
	var _Core = __webpack_require__(9);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	var _Draw = __webpack_require__(4);
	
	var _Draw2 = _interopRequireDefault(_Draw);
	
	var _Anim = __webpack_require__(5);
	
	var _Anim2 = _interopRequireDefault(_Anim);
	
	var _Elements = __webpack_require__(8);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Components = __webpack_require__(16);
	
	var _Components2 = _interopRequireDefault(_Components);
	
	var _Preload = __webpack_require__(22);
	
	var _Preload2 = _interopRequireDefault(_Preload);
	
	var _Sound = __webpack_require__(24);
	
	var _Sound2 = _interopRequireDefault(_Sound);
	
	var _release = __webpack_require__(13);
	
	var _release2 = _interopRequireDefault(_release);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var status = {
	  initialized: true,
	  version: _release2.default.version,
	  build: _release2.default.build
	};
	
	console.log('Evolve JS initialized', status);
	
	var evolve = {
	  Core: _Core2.default,
	  Draw: _Draw2.default,
	  Anim: _Anim2.default,
	  Preload: _Preload2.default,
	  Sound: _Sound2.default,
	  Elements: _Elements2.default,
	  Components: _Components2.default,
	  status: status
	};
	
	exports.default = evolve;
	exports.Core = _Core2.default;
	exports.Draw = _Draw2.default;
	exports.Anim = _Anim2.default;
	exports.Preload = _Preload2.default;
	exports.Sound = _Sound2.default;
	exports.Elements = _Elements2.default;
	exports.Components = _Components2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Anim = __webpack_require__(5);
	
	var _Anim2 = _interopRequireDefault(_Anim);
	
	var _Draw = __webpack_require__(4);
	
	var _Draw2 = _interopRequireDefault(_Draw);
	
	var _Helpers = __webpack_require__(3);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs an Element instance
	 * @class Element
	 * @classdesc Element Class
	 //* @extends Container
	 * @param {Object} options the options object to be merged with defaults
	 * @type {Element}
	 * @public
	 */
	var Element = function (_Draw$Container) {
	  _inherits(Element, _Draw$Container);
	
	  function Element() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Element);
	
	    // this.preInit(options).then(() => {
	    //   return this.drawElement();
	    // }).then(() => {
	    //   this.bindEvents();
	    //   return this.init();
	    // }).then(() => {
	    //   this.postInit();
	    // });
	    var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this));
	
	    _this.preInit(options);
	    _this.drawElement();
	    _this.bindEvents();
	    _this.init();
	    _this.postInit();
	    return _this;
	  }
	
	  _createClass(Element, [{
	    key: 'preInit',
	    value: function preInit(options) {
	      // return new Promise((resolve, reject) => {
	      this.initDefaults();
	      this.initSettings(options);
	      this.initData();
	
	      //   Function.isFunction(resolve) && resolve();
	      // });
	    }
	
	    /**
	     * initializes default settings for Element instance
	     * @memberOf Element
	     * @method initDefaults
	     * @instance
	     * @param {Object} defaults the defaults object for Element instance
	     */
	
	  }, {
	    key: 'initDefaults',
	    value: function initDefaults(defaults) {
	      this.inherit({
	        debug: {
	          fill: 'rgba(0,0,0,0.4)',
	          stroke: {
	            size: 1,
	            color: '#f00'
	          },
	          regPoint: {
	            radius: 3,
	            fill: '#f00'
	          }
	        },
	        defaults: {
	          debug: false,
	          parent: null,
	          position: {
	            x: 0,
	            y: 0
	          },
	          scale: {
	            x: 1,
	            y: 1
	          },
	          size: {
	            width: 0,
	            height: 0
	          },
	          cache: false,
	          mask: false,
	          fill: 'rgba(255,255,255,0.001)',
	          stroke: {
	            size: 0,
	            radius: 0,
	            color: 'rgba(0,0,0,0.001)'
	          },
	          shadow: false,
	          align: null,
	          regPoint: false,
	          regPointAlign: 'center middle',
	          horizontalModes: ['left', 'center', 'right'],
	          verticalModes: ['top', 'middle', 'bottom'],
	          events: {}
	        }.inherit(defaults)
	      });
	    }
	  }, {
	    key: 'getAlignSettings',
	    value: function getAlignSettings() {
	      var alignOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var alignSettings = {
	        horizontal: null,
	        vertical: null
	      };
	
	      if (!!alignOptions) {
	        if (String.isString(alignOptions) || Array.isArray(alignOptions)) {
	          var alignOptionsArray = alignOptions;
	
	          if (String.isString(alignOptions)) {
	            alignOptionsArray = alignOptions.split(' ');
	          }
	
	          alignSettings.inherit({
	            horizontal: this.settings.horizontalModes.intersection(alignOptionsArray).first(),
	            vertical: this.settings.verticalModes.intersection(alignOptionsArray).first()
	          });
	        } else if (Object.isObject(alignOptions) && (!!alignOptions.horizontal || !!alignOptions.vertical)) {
	          alignSettings.inherit(alignOptions);
	        }
	      }
	
	      return alignSettings;
	    }
	
	    /**
	     * initializes settings object for the Element instance
	     * @memberOf Element
	     * @method initSettings
	     * @instance
	     * @param {Object} options the options object to be merged with defaults
	     */
	
	  }, {
	    key: 'initSettings',
	    value: function initSettings(options) {
	      this.inherit({
	        settings: this.defaults.inherit(true, options)
	      });
	
	      !!this.settings.debug && this.settings.inherit(this.debug);
	
	      this.settings.inherit({
	        align: this.getAlignSettings(this.settings.align),
	        regPointAlign: this.getAlignSettings(this.settings.regPointAlign)
	      });
	    }
	
	    /**
	     * initializes data object for the Element instance
	     * @memberOf Element
	     * @method initData
	     * @instance
	     */
	
	  }, {
	    key: 'initData',
	    value: function initData() {
	      this.data = {};
	    }
	  }, {
	    key: 'preDrawElement',
	    value: function preDrawElement() {
	      // return new Promise((resolve, reject) => {
	      if (this.settings.parent) {
	        this.settings.parent.addChild(this);
	      }
	
	      this.setScale(this.settings.scale);
	      this.setComputedBounds(this.settings.size);
	      this.setReg(this.settings.regPointAlign);
	      //   Function.isFunction(resolve) && resolve();
	      // });
	    }
	  }, {
	    key: 'drawBackgroundElements',
	    value: function drawBackgroundElements() {
	      this.background = _Helpers2.default.createRect.apply(_Helpers2.default, [this.settings.pick(['fill', 'stroke'])].concat(_toConsumableArray(this.bounds)));
	      this.addChild(this.background);
	    }
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      //TODO:
	    }
	  }, {
	    key: 'drawBehaviorElements',
	    value: function drawBehaviorElements() {
	      this.setMask(this.settings.mask);
	      this.setShadow(this.settings.shadow);
	      this.setCache(this.settings.cache);
	    }
	  }, {
	    key: 'drawRegPoint',
	    value: function drawRegPoint() {
	      if (!!this.settings.regPoint) {
	        this.regPoint = _Helpers2.default.createCircle.apply(_Helpers2.default, [this.settings.regPoint].concat(_toConsumableArray(this.bounds)));
	        this.addChild(this.regPoint);
	
	        this.regPoint.inherit({
	          x: this.regX,
	          y: this.regY
	        });
	
	        this.regPointText = _Helpers2.default.createText('r:' + this.regX.toFixed(0) + 'x' + this.regY.toFixed(0) + '\np:' + this.getComputedBounds().x.toFixed(0) + 'x' + this.getComputedBounds().y.toFixed(0), '16px Verdana', '#fff').inherit({
	          textAlign: this.settings.regPointAlign.horizontal || 'center',
	          textBaseline: this.settings.regPointAlign.vertical || 'middle'
	        });
	
	        this.addChild(this.regPointText);
	
	        var regPointTextPosition = {
	          x: this.regX,
	          y: this.regY
	        };
	
	        if (this.settings.horizontalModes[0] === this.settings.regPointAlign.horizontal) {
	          regPointTextPosition.x += 5;
	        } else if (this.settings.horizontalModes[2] === this.settings.regPointAlign.horizontal) {
	          regPointTextPosition.x -= 5;
	        }
	
	        if (this.settings.verticalModes[0] === this.settings.regPointAlign.vertical) {
	          regPointTextPosition.y += 5;
	        } else if (this.settings.verticalModes[1] === this.settings.regPointAlign.vertical) {
	          if (this.settings.horizontalModes[1] === this.settings.regPointAlign.horizontal) {
	            regPointTextPosition.y += 10;
	          } else {
	            regPointTextPosition.y -= 10;
	          }
	        } else if (this.settings.verticalModes[2] === this.settings.regPointAlign.vertical) {
	          regPointTextPosition.y -= 20;
	        }
	
	        this.regPointText.inherit(regPointTextPosition);
	      }
	    }
	  }, {
	    key: 'drawBoundsTexts',
	    value: function drawBoundsTexts() {
	      if (!!this.settings.debug) {
	        this.boundsText = _Helpers2.default.createText('s:' + this.getComputedBounds().width.toFixed(0) + 'x' + this.getComputedBounds().height.toFixed(0), '16px Verdana', '#fff').inherit({
	          textAlign: this.settings.regPointAlign.horizontal === 'right' && this.settings.regPointAlign.vertical === 'bottom' ? 'center' : 'left',
	          textBaseline: 'middle'
	        });
	
	        this.addChild(this.boundsText);
	
	        var boundsTextAlign = this.settings.regPointAlign.horizontal === 'right' && this.settings.regPointAlign.vertical === 'bottom' ? 'center middle' : 'right bottom';
	
	        _Helpers2.default.align(this.boundsText, null, boundsTextAlign, false);
	
	        if (this.boundsText.textAlign === 'left') {
	          this.boundsText.inherit({
	            x: this.boundsText.x - 10
	          });
	        }
	      }
	    }
	  }, {
	    key: 'drawOverlayElements',
	    value: function drawOverlayElements() {
	      this.drawRegPoint();
	      this.drawBoundsTexts();
	    }
	  }, {
	    key: 'postDrawElement',
	    value: function postDrawElement() {}
	    // if(!!this.settings.scale) {
	    //   this.inherit({
	    //     scaleX: this.settings.scale.x,
	    //     scaleY: this.settings.scale.y,
	    //   });
	    // }
	
	    // return new Promise((resolve, reject) => {
	    // if (!!this.settings.align) {
	    //   this.align(null, this.settings.align);
	    // } else {
	    //   this.setPosition(this.settings.position);
	    // }
	
	    //   Function.isFunction(resolve) && resolve();
	    // });
	
	
	    /**
	     * draws all graphic elements of the Element instance
	     * @memberOf Element
	     * @method draw
	     * @instance
	     */
	
	  }, {
	    key: 'drawElement',
	    value: function drawElement() {
	      // return new Promise((resolve, reject) => {
	      // this.preDrawElement().then(() => {
	      this.preDrawElement();
	      this.drawBackgroundElements();
	      this.drawElements();
	      this.drawBehaviorElements();
	
	      if (!!this.settings.align) {
	        this.align(null, this.settings.align);
	      } else {
	        this.setPosition(this.settings.position);
	      }
	
	      this.drawOverlayElements();
	
	      // return this.postDrawElement();
	      this.postDrawElement();
	      //   }).then(() => {
	      //     Function.isFunction(resolve) && resolve();
	      //   });
	      // });
	    }
	
	    /**
	     * sets to center/middle the regPoint of the Element instance
	     * @memberOf Element
	     * @method setReg
	     * @instance
	     */
	
	  }, {
	    key: 'setReg',
	    value: function setReg() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center middle';
	
	      var bounds = this.getBounds();
	      var regPointAlignSettings = this.getAlignSettings(mode);
	
	      var reg = {
	        regX: 0,
	        regY: 0
	      };
	
	      if (!!regPointAlignSettings.horizontal) {
	        if (this.settings.horizontalModes[1] === regPointAlignSettings.horizontal) {
	          reg.inherit({
	            regX: bounds.width * 0.5
	          });
	        } else if (this.settings.horizontalModes[2] === regPointAlignSettings.horizontal) {
	          reg.inherit({
	            regX: bounds.width
	          });
	        }
	      }
	
	      if (!!regPointAlignSettings.vertical) {
	        if (this.settings.verticalModes[1] === regPointAlignSettings.vertical) {
	          reg.inherit({
	            regY: bounds.height * 0.5
	          });
	        } else if (this.settings.verticalModes[2] === regPointAlignSettings.vertical) {
	          reg.inherit({
	            regY: bounds.height
	          });
	        }
	      }
	
	      this.inherit(reg);
	
	      return this;
	    }
	
	    /**
	     * sets or updates the position of the Element instance
	     * @memberOf Element
	     * @method setPosition
	     * @instance
	     * @param {Object} [positionOptions=null] can contain x and y or only one or them
	     * @param {Number} [positionOptions.x=0] the x position
	     * @param {Number} [positionOptions.y=0] the y position
	     * @param {Boolean} [override=false] specify to override actual Element position
	     * @param {Boolean} [force=true] ...
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setPosition',
	    value: function setPosition() {
	      var positionOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (!!positionOptions) {
	        if (force) {
	          this.settings.position = positionOptions;
	        } else {
	          this.settings.position.inherit(positionOptions);
	        }
	      }
	
	      if (!!this.settings.position) {
	        if (!!this.settings.position.x) {
	          if (!!override) {
	            this.x = this.settings.position.x;
	          } else {
	            this.x += this.settings.position.x;
	          }
	        }
	
	        if (!!this.settings.position.y) {
	          if (!!override) {
	            this.y = this.settings.position.y;
	          } else {
	            this.y += this.settings.position.y;
	          }
	        }
	      }
	
	      return this;
	    }
	
	    /**
	     * sets or updates the scaling of the Element instance
	     * @memberOf Element
	     * @method setScale
	     * @instance
	     * @param {Object|Number} scaleOptions can be an object with x and y couple or only a number to be used for both
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setScale',
	    value: function setScale() {
	      var scaleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!!scaleOptions) {
	        if (force) {
	          this.settings.scale = scaleOptions;
	        } else {
	          this.settings.scale.inherit(scaleOptions);
	        }
	      }
	
	      if (!!this.settings.scale) {
	        var scale = {
	          x: 1,
	          y: 1
	        };
	
	        if (Number.isNumber(this.settings.scale)) {
	          scale.inherit({
	            x: this.settings.scale,
	            y: this.settings.scale
	          });
	        } else if (Object.isObject(this.settings.scale)) {
	          scale.inherit({
	            x: this.settings.scale.x,
	            y: this.settings.scale.y
	          });
	        }
	
	        this.settings.scale = scale;
	
	        this.inherit({
	          scaleX: this.settings.scale.x,
	          scaleY: this.settings.scale.y
	        });
	      }
	
	      return this;
	    }
	
	    /**
	     * sets or updates the bounds of the Element instance
	     * @memberOf Element
	     * @method setComputedBounds
	     * @instance
	     * @param {Object|Number} boundsOptions ...
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setComputedBounds',
	    value: function setComputedBounds() {
	      var boundsOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!!boundsOptions) {
	        if (force) {
	          this.settings.size = boundsOptions;
	        } else {
	          this.settings.size.inherit(boundsOptions);
	        }
	      }
	
	      if (!this.bounds && !!this.settings.size) {
	        if (String.isPercentage(this.settings.size) || Number.isNumber(this.settings.size)) {
	          this.settings.size = {
	            width: this.settings.size,
	            height: this.settings.size
	          };
	        }
	
	        if (String.isPercentage(this.settings.size.width) && !!this.parent) {
	          this.settings.size.width = this.parent.getComputedBounds().width * this.settings.size.width.parsePercentage();
	        }
	
	        if (String.isPercentage(this.settings.size.height) && !!this.parent) {
	          this.settings.size.height = this.parent.getComputedBounds().height * this.settings.size.height.parsePercentage();
	        }
	
	        this.bounds = [0, 0, this.settings.size.width * this.settings.scale.x, this.settings.size.height * this.settings.scale.y];
	        this.setBounds.apply(this, _toConsumableArray(this.bounds));
	      }
	
	      return this;
	    }
	
	    /**
	     * sets or updates the Mask of the Element instance
	     * @memberOf Element
	     * @method setMask
	     * @instance
	     * @param {Object|Shadow} maskOptions can be an object with {color, x, y, blur}<br>or directly an instance of Shadow (DrawJS)
	     * @param {Boolean} force ....
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setMask',
	    value: function setMask() {
	      var maskOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!!maskOptions) {
	        if (force) {
	          this.settings.mask = maskOptions;
	        } else {
	          this.settings.mask.inherit(maskOptions);
	        }
	      }
	
	      if (!!this.settings.mask) {
	        this.maskShape = this.settings.mask;
	
	        if (!(this.settings.mask instanceof _Draw2.default.Shape) && !(this.settings.mask instanceof _Draw2.default.DisplayObject)) {
	          this.maskBounds = [0, 0, this.settings.size.width * this.settings.scale.x, this.settings.size.height * this.settings.scale.y];
	
	          if (Object.isObject(this.settings.mask)) {
	            this.maskBounds = [0, 0, this.settings.size.width * this.settings.scale.x * this.settings.mask.scale, this.settings.size.height * this.settings.scale.y * this.settings.mask.scale];
	            this.maskShape = _Helpers2.default.createRect.apply(_Helpers2.default, [this.settings.mask.pick(['fill', 'stroke'])].concat(_toConsumableArray(this.maskBounds)));
	          } else if (Number.isNumber(this.settings.mask)) {
	            this.maskBounds = [0, 0, this.settings.size.width * this.settings.scale.x * this.settings.mask, this.settings.size.height * this.settings.scale.y * this.settings.mask];
	            this.maskShape = _Helpers2.default.createRect.apply(_Helpers2.default, [this.settings.pick(['fill', 'stroke'])].concat(_toConsumableArray(this.maskBounds)));
	          }
	
	          this.maskShape.inherit({
	            x: this.bounds[2] * 0.5 - this.maskBounds[2] * 0.5,
	            y: this.bounds[3] * 0.5 - this.maskBounds[3] * 0.5
	          });
	        }
	
	        if (!!this.settings.debug) {
	          this.addChild(this.maskShape);
	        }
	
	        this.mask = this.maskShape;
	      }
	
	      return this;
	    }
	
	    /**
	     * sets or updates the Shadow of the Element instance
	     * @memberOf Element
	     * @method setShadow
	     * @instance
	     * @param {Object|Shadow} shadowOptions can be an object with {color, x, y, blur}<br>or directly an instance of Shadow (DrawJS)
	     * @param {Boolean} force ....
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setShadow',
	    value: function setShadow() {
	      var shadowOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!!shadowOptions) {
	        if (force) {
	          this.settings.shadow = shadowOptions;
	        } else {
	          this.settings.shadow.inherit(shadowOptions);
	        }
	
	        if (!!this.settings.shadow) {
	          var shadow = null;
	
	          if (Object.isObject(this.settings.shadow)) {
	            var shadowSettings = [this.settings.shadow.color, this.settings.shadow.x, this.settings.shadow.y, this.settings.shadow.blur];
	
	            shadow = new (Function.prototype.bind.apply(_Draw2.default.Shadow, [null].concat(shadowSettings)))();
	          } else if (this.settings.shadow instanceof _Draw2.default.Shadow) {
	            shadow = this.settings.shadow;
	          }
	
	          this.inherit({
	            shadow: shadow
	          });
	        }
	      } else {
	        this.settings.shadow = null;
	
	        this.inherit({
	          shadow: null
	        });
	      }
	
	      return this;
	    }
	
	    /**
	     * sets or updates the Cache of the Element instance
	     * @memberOf Element
	     * @method setCache
	     * @instance
	     * @param {Object|Shadow} cacheOptions ..
	     * @param {Boolean} force ....
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setCache',
	    value: function setCache() {
	      var cacheOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!!cacheOptions) {
	        if (force) {
	          this.settings.cache = cacheOptions;
	        } else {
	          this.settings.cache.inherit(cacheOptions);
	        }
	
	        if (!!this.settings.cache) {
	          this.cache.apply(this, [this.bounds.x - 5, this.bounds.y - 5, this.getComputedBounds().width, this.getComputedBounds().height]);
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: 'getAlignPosition',
	    value: function getAlignPosition() {
	      var parentElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left top';
	
	      if (!parentElement) {
	        parentElement = this.parent;
	      }
	
	      var parentBounds = parentElement.getBounds();
	      var bounds = this.getBounds();
	      var alignSettings = this.getAlignSettings(mode);
	
	      var position = {
	        x: 0,
	        y: 0
	      };
	
	      if (!!alignSettings.horizontal) {
	        if (this.settings.horizontalModes[0] === alignSettings.horizontal) {
	          if (this.settings.horizontalModes[0] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: 0
	            });
	          } else if (this.settings.horizontalModes[1] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: bounds.width * 0.5 * this.settings.scale.x
	            });
	          } else if (this.settings.horizontalModes[2] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: bounds.width * this.settings.scale.x
	            });
	          }
	        } else if (this.settings.horizontalModes[1] === alignSettings.horizontal) {
	          if (this.settings.horizontalModes[0] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: parentBounds.width * 0.5 - bounds.width * 0.5 * this.settings.scale.x
	            });
	          } else if (this.settings.horizontalModes[1] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: parentBounds.width * 0.5
	            });
	          } else if (this.settings.horizontalModes[2] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: parentBounds.width * 0.5 + bounds.width * 0.5 * this.settings.scale.x
	            });
	          }
	        } else if (this.settings.horizontalModes[2] === alignSettings.horizontal) {
	          if (this.settings.horizontalModes[0] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: parentBounds.width - bounds.width * this.settings.scale.x
	            });
	          } else if (this.settings.horizontalModes[1] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: parentBounds.width - bounds.width * 0.5 * this.settings.scale.x
	            });
	          } else if (this.settings.horizontalModes[2] === this.settings.regPointAlign.horizontal) {
	            position.inherit({
	              x: parentBounds.width
	            });
	          }
	        }
	      }
	
	      if (!!alignSettings.vertical) {
	        if (this.settings.verticalModes[0] === alignSettings.vertical) {
	          if (this.settings.verticalModes[0] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: 0
	            });
	          } else if (this.settings.verticalModes[1] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: bounds.height * 0.5 * this.settings.scale.y
	            });
	          } else if (this.settings.verticalModes[2] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: bounds.height * this.settings.scale.y
	            });
	          }
	        } else if (this.settings.verticalModes[1] === alignSettings.vertical) {
	          if (this.settings.verticalModes[0] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: parentBounds.height * 0.5 - bounds.height * 0.5 * this.settings.scale.y
	            });
	          } else if (this.settings.verticalModes[1] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: parentBounds.height * 0.5
	            });
	          } else if (this.settings.verticalModes[2] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: parentBounds.height * 0.5 + bounds.height * 0.5 * this.settings.scale.y
	            });
	          }
	        } else if (this.settings.verticalModes[2] === alignSettings.vertical) {
	          if (this.settings.verticalModes[0] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: parentBounds.height - bounds.height * this.settings.scale.y
	            });
	          } else if (this.settings.verticalModes[1] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: parentBounds.height - bounds.height * 0.5 * this.settings.scale.y
	            });
	          } else if (this.settings.verticalModes[2] === this.settings.regPointAlign.vertical) {
	            position.inherit({
	              y: parentBounds.height
	            });
	          }
	        }
	      }
	
	      return position;
	    }
	
	    /**
	     * Aligns the Element instance, based on it's parent bounds or specified parentElement bounds and mode parameter
	     * @memberOf Element
	     * @method align
	     * @instance
	     * @param {Object|null} parentElement if null, it considers the actual Element instance parent, otherwise it aligns in base of the specified parentElement
	     * @param {String} mode can be a set of one or two strings (blank separated) in any order, for horizontalModes (left, center, right), for verticalModes (top, middle, bottom)
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'align',
	    value: function align() {
	      var parentElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left top';
	
	      this.settings.inherit({
	        position: this.getAlignPosition(parentElement, mode)
	      });
	
	      this.setPosition(null, true);
	
	      return this;
	    }
	
	    /**
	     * returns the actual computed bounds of the Element instance, including scale factor and top, right, bottom, left coordinates
	     * @memberOf Element
	     * @method getComputedBounds
	     * @instance
	     * @return {Object} the actual Element instance computed bounds object<br>
	     * <pre>
	     *   {
	     *     {
	     *       top: number,
	     *       right: number,
	     *       bottom: number,
	     *       left: number,
	     *       x: number,
	     *       y: number,
	     *       width: number,
	     *       height: number
	     *     }
	     *   }
	     * </pre>
	     */
	
	  }, {
	    key: 'getComputedBounds',
	    value: function getComputedBounds() {
	      var bounds = this.getBounds();
	
	      return {
	        top: this.y - bounds.height * 0.5,
	        right: this.x + bounds.width * 0.5,
	        bottom: this.y + bounds.height * 0.5,
	        left: this.x - bounds.width * 0.5,
	        x: this.x,
	        y: this.y,
	        width: bounds.width,
	        height: bounds.height
	      };
	    }
	
	    /**
	     * binds all events specified in the settings object for the Element instance, it supports all DrawJS classes events (eg. click, mouseover, etc...)
	     * @memberOf Element
	     * @method bindEvents
	     * @instance
	     */
	
	  }, {
	    key: 'bindEvents',
	    value: function bindEvents() {
	      var _this2 = this;
	
	      if (!!this.settings.events) {
	        this.settings.events.each(function (value, key) {
	          if (Function.isFunction(value)) {
	            _this2.on(key, value);
	          }
	        });
	      }
	    }
	
	    /**
	     * empty init method, to be overriden in classes that extends Element, to use for all those initializations you might need after having rendered the Element
	     * @memberOf Element
	     * @method init
	     * @instance
	     */
	
	  }, {
	    key: 'init',
	    value: function init() {
	      // return new Promise((resolve, reject) => {
	      //   Function.isFunction(resolve) && resolve();
	      // });
	    }
	  }, {
	    key: 'postInit',
	    value: function postInit() {
	      //TODO:
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { override: false, delay: 0 };
	      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var _this3 = this;
	
	      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;
	      var ease = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Anim2.default.Ease.linear;
	
	      return new Promise(function (resolve, reject) {
	        _Anim2.default.Tween.get(_this3, options).wait(options.delay).to(to, time, ease).call(function () {
	          _Anim2.default.Tween.removeTweens(_this3);
	          resolve();
	        });
	      });
	    }
	  }]);
	
	  return Element;
	}(_Draw2.default.Container);
	
	exports.default = Element;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Draw = __webpack_require__(4);
	
	var _Draw2 = _interopRequireDefault(_Draw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class Helpers
	 * @classdesc all the helpers we need to draw the elements
	 */
	var Helpers = function () {
	  function Helpers() {
	    _classCallCheck(this, Helpers);
	  }
	
	  _createClass(Helpers, null, [{
	    key: 'setBoxSize',
	
	
	    /**
	     * sets the box size of an DrawJS element
	     * @memberOf Helpers
	     * @method setBoxSize
	     * @static
	     * @param {Object|Container|Element} element can be an Object, an DrawJS instance, a CreateJS Core Elements instance
	     * @param {Number} width the width
	     * @param {Number} height the height
	     * @param {Boolean} css specity if you want to override also the css box size properties
	     * @return {Object|Container|Element}
	     */
	    value: function setBoxSize(element) {
	      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var css = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      if (!!css) {
	        element.style.width = width + 'px';
	        element.style.height = height + 'px';
	      }
	
	      return element.inherit({
	        width: width,
	        height: height
	      });
	    }
	
	    /**
	     * sets the scale factor of an DrawJS element
	     * @memberOf Helpers
	     * @method scale
	     * @static
	     * @param {Object|Container|Element} element can be an Object, an DrawJS instance, a CreateJS Core Elements instance
	     * @param {Number|Object} scale the scale factor to be used for both scaleX and scaleY
	     * @return {Object|Container|Element}
	     */
	
	  }, {
	    key: 'scale',
	    value: function scale(element, _scale) {
	      return element.inherit({
	        scaleX: _scale,
	        scaleY: _scale
	      });
	    }
	
	    /**
	     * aligns the reg point or an element
	     * @memberOf Helpers
	     * @method alignRegPoint
	     * @static
	     * @param {Object|Container|Element} element can be an Object, an DrawJS instance, a CreateJS Core Elements instance
	     * @param {String} mode can be a couple of word for horizontal or vertical align, in any order<br>
	     *   accepts the following modes<br>
	     *   <ul>
	     *     <li><b>Horizontal Modes</b>: left, center, right</li>
	     *     <li><b>Vertical Modes</b>: top, middle, bottom</li>
	     *   </ul>
	     * @return {Object|Container|Element}
	     */
	
	  }, {
	    key: 'alignRegPoint',
	    value: function alignRegPoint(element) {
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left top';
	
	      var bounds = element.getBounds();
	      var modes = mode.toArray(' ');
	      var horizontalModes = ['left', 'center', 'right'];
	      var verticalModes = ['top', 'middle', 'bottom'];
	
	      return element.inherit({
	        regX: horizontalModes.contains(modes) ? bounds.width * 0.5 : 0,
	        regY: verticalModes.contains(modes) ? bounds.height * 0.5 : 0
	      });
	    }
	
	    /**
	     * Aligns an element (horizontally, vertically or both) based on it's parent bounds.
	     * @memberOf Helpers
	     * @method align
	     * @static
	     * @param {Object|Container|Element} element can be an Object, an DrawJS instance, a CreateJS Core Elements instance
	     * @param {null|Object|Container|Element} parent can be an Object, an DrawJS instance, a CreateJS Core Elements instance<br>
	     *   if null, it takes automatically the parent property of element parameter
	     * @param {String} mode can be a couple of word for horizontal or vertical align, in any order<br>
	     *   accepts the following modes<br>
	     *   <ul>
	     *     <li><b>Horizontal Modes</b>: left, center, right</li>
	     *     <li><b>Vertical Modes</b>: top, middle, bottom</li>
	     *   </ul>
	     * @param {Boolean} regPoint enabled alignment also on registration point
	     * @param {null|String} regPointMode can be a couple of word for horizontal or vertical align, in any order<br>
	     *   accepts the following modes<br>
	     *   <ul>
	     *     <li><b>Horizontal Modes</b>: left, center, right</li>
	     *     <li><b>Vertical Modes</b>: top, middle, bottom</li>
	     *   </ul><br>
	     *   if null it considers mode parameter as fallback
	     * @return {Object|Container|Element}
	     */
	
	  }, {
	    key: 'align',
	    value: function align(element) {
	      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left top';
	      var regPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	      var regPointMode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      if (!parent) {
	        parent = element.parent;
	      }
	
	      var parentBounds = parent.getBounds();
	      var elementBounds = element.getBounds();
	      var modes = mode.toArray(' ');
	      var horizontalModes = ['left', 'center', 'right'];
	      var verticalModes = ['top', 'middle', 'bottom'];
	
	      if (!!regPoint) {
	        this.alignRegPoint(element, regPointMode || mode);
	      }
	
	      var position = {
	        x: 0,
	        y: 0
	      };
	
	      if (horizontalModes.contains(modes)) {
	        if (modes.contains('center')) {
	          position.inherit({
	            x: parentBounds.width * 0.5 + (!!regPoint && !(element instanceof _Draw2.default.Bitmap || element instanceof _Draw2.default.Sprite) ? elementBounds.width * 0.5 : 0)
	          });
	        } else if (modes.contains('left')) {
	          position.inherit({
	            x: !!regPoint ? elementBounds.width * 0.5 : 0
	          });
	        } else if (modes.contains('right')) {
	          position.inherit({
	            x: parentBounds.width - elementBounds.width + (!!regPoint ? elementBounds.width * 0.5 : 0)
	          });
	        }
	      }
	
	      if (verticalModes.contains(modes)) {
	        if (modes.contains('middle')) {
	          position.inherit({
	            y: parentBounds.height * 0.5 + (!!regPoint && !(element instanceof _Draw2.default.Bitmap || element instanceof _Draw2.default.Sprite) ? elementBounds.width * 0.5 : 0)
	          });
	        } else if (modes.contains('top')) {
	          position.inherit({
	            y: !!regPoint ? elementBounds.height * 0.5 : 0
	          });
	        } else if (modes.contains('bottom')) {
	          position.inherit({
	            y: parentBounds.height - elementBounds.height
	          });
	        }
	      }
	
	      return element.inherit(position);
	    }
	
	    /**
	     * creates an DrawJS Container instance based on bounds parameters
	     * @memberOf Helpers
	     * @method createContainer
	     * @statuc
	     * @param {Arguments} bounds the bounds parameter will be passed to setBounds method of DrawJS Container class<br>
	     *   so it has to be an array with this sequence<br>
	     *   <ul>
	     *     <li>{Number} x</li>
	     *     <li>{Number} y</li>
	     *     <li>{Number} width</li>
	     *     <li>{Number} height</li>
	     *   </ul>
	     * @return {Container}
	     */
	
	  }, {
	    key: 'createContainer',
	    value: function createContainer() {
	      var container = new _Draw2.default.Container().inherit({
	        x: arguments.length <= 0 ? undefined : arguments[0],
	        y: arguments.length <= 1 ? undefined : arguments[1]
	      });
	
	      container.setBounds.apply(container, arguments);
	
	      return container;
	    }
	
	    /**
	     * creates an DrawJS Graphics instance
	     * @memberOf Helpers
	     * @method createGraphics
	     * @static
	     * @param {Object} options the options can contain
	     * @param {String|Object} options.fill color for filling graphics<br>
	     * @param {Array} options.fill.colors colors to create a linear gradient fill
	     * @param {Array} options.fill.ratios color ratios to create a linear gradient fill
	     * @param {Array} options.fill.points start & stop points to create a linear gradient fill
	     * @param {String|Object} options.stroke stroke options, if string it creates a stroke with size 1
	     * @param {Number} options.stroke.size the size
	     * @param {String} options.stroke.color the color
	     * @param {Arguments} bounds the bounds parameter will be passed to setBounds method of DrawJS Container class<br>
	     *   so it has to be an array with this sequence<br>
	     *   <ul>
	     *     <li>{Number} x</li>
	     *     <li>{Number} y</li>
	     *     <li>{Number} width</li>
	     *     <li>{Number} height</li>
	     *   </ul>
	     * @return {Graphics}
	     */
	
	  }, {
	    key: 'createGraphics',
	    value: function createGraphics() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var defaults = {
	        fill: false,
	        stroke: false
	      };
	
	      var settings = defaults.inherit(true, options);
	
	      var graphics = new _Draw2.default.Graphics();
	
	      if (!!settings.fill) {
	        if (Object.isObject(settings.fill)) {
	          if (!!settings.fill.colors && !!settings.fill.ratios && !!settings.fill.points) {
	            graphics.beginLinearGradientFill.apply(graphics, [[].concat(_toConsumableArray(settings.fill.colors)), [].concat(_toConsumableArray(settings.fill.ratios))].concat(_toConsumableArray(settings.fill.points)));
	          }
	        } else {
	          graphics.beginFill(settings.fill);
	        }
	      }
	
	      if (!!settings.stroke) {
	        if (String.isString(settings.stroke)) {
	          settings.inherit({
	            stroke: {
	              size: 1,
	              color: settings.stroke
	            }
	          });
	        }
	
	        graphics.setStrokeStyle(settings.stroke.size);
	        graphics.beginStroke(settings.stroke.color);
	      }
	
	      return graphics;
	    }
	
	    /**
	     * creates an DrawJS Rect Shape instance
	     * @memberOf Helpers
	     * @method createRect
	     * @static
	     * @param {Object} options the options can contain
	     * @param {String|Object} options.fill color for filling graphics<br>
	     * @param {Array} options.fill.colors colors to create a linear gradient fill
	     * @param {Array} options.fill.ratios color ratios to create a linear gradient fill
	     * @param {Array} options.fill.points start & stop points to create a linear gradient fill
	     * @param {String|Object} options.stroke stroke options, if string it creates a stroke with size 1
	     * @param {Number} options.stroke.size the size
	     * @param {String} options.stroke.color the color
	     * @param {Boolean|Number|Array} options.stroke.radius
	     *   <br>if false it draws a rect
	     *   <br>if Number it draws a round rect
	     *   <br>if Array it draws a round rect complex (array has to respect the arguments sequence of drawRoundRectComplex method of DrawJS Graphics class
	     * @param {Arguments} bounds the bounds parameter will be passed to setBounds method of DrawJS Container class<br>
	     *   so it has to be an array with this sequence<br>
	     *   <ul>
	     *     <li>{Number} x</li>
	     *     <li>{Number} y</li>
	     *     <li>{Number} width</li>
	     *     <li>{Number} height</li>
	     *   </ul>
	     * @return {Shape}
	     */
	
	  }, {
	    key: 'createRect',
	    value: function createRect() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      for (var _len = arguments.length, bounds = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        bounds[_key - 1] = arguments[_key];
	      }
	
	      var graphics = this.createGraphics.apply(this, [options].concat(bounds));
	
	      if (!!options.stroke.radius) {
	        if (Array.isArray(options.stroke.radius)) {
	          graphics.drawRoundRectComplex.apply(graphics, bounds.concat(_toConsumableArray(options.stroke.radius)));
	        } else if (Number.isNumber(options.stroke.radius)) {
	          graphics.drawRoundRect.apply(graphics, bounds.concat([options.stroke.radius]));
	        }
	      } else {
	        graphics.drawRect.apply(graphics, bounds);
	      }
	
	      graphics.endFill();
	      graphics.endStroke();
	
	      var rect = new _Draw2.default.Shape(graphics);
	      rect.setBounds.apply(rect, bounds);
	
	      return rect;
	    }
	
	    /**
	     * creates an DrawJS Circle Shape instance
	     * @memberOf Helpers
	     * @method createCircle
	     * @static
	     * @param {Object} options the options can contain
	     * @param {String|Object} options.fill color for filling graphics
	     * @param {Array} options.fill.colors colors to create a linear gradient fill
	     * @param {Array} options.fill.ratios color ratios to create a linear gradient fill
	     * @param {Array} options.fill.points start & stop points to create a linear gradient fill
	     * @param {String|Object} options.stroke stroke options, if string it creates a stroke with size 1
	     * @param {Number} options.stroke.size the size
	     * @param {String} options.stroke.color the color
	     * @param {Number} options.radius the radius of the circle
	     * @param {Arguments} bounds the bounds parameter will be passed to setBounds method of DrawJS Container class<br>
	     *   so it has to be an array with this sequence<br>
	     *   <ul>
	     *     <li>{Number} x</li>
	     *     <li>{Number} y</li>
	     *     <li>{Number} width</li>
	     *     <li>{Number} height</li>
	     *   </ul>
	     * @return {Shape}
	     */
	
	  }, {
	    key: 'createCircle',
	    value: function createCircle() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var defaults = {
	        radius: 1
	      };
	
	      var settings = defaults.inherit(true, options);
	
	      for (var _len2 = arguments.length, bounds = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        bounds[_key2 - 1] = arguments[_key2];
	      }
	
	      var graphics = this.createGraphics.apply(this, [settings].concat(bounds));
	      graphics.drawCircle(0, 0, settings.radius);
	
	      var circle = new _Draw2.default.Shape(graphics);
	      circle.setBounds.apply(circle, bounds);
	
	      return circle;
	    }
	
	    /**
	     * creates an DrawJS Text instance
	     * @memberOf Helpers
	     * @method createText
	     * @static
	     * @param {String} text the text to be rendered
	     * @param {String} font font options as expected by the DrawJS Text class
	     * @param {String} color the color of the text
	     * @return {Text}
	     */
	
	  }, {
	    key: 'createText',
	    value: function createText(text, font, color) {
	      return new _Draw2.default.Text(text, font, color);
	    }
	
	    /**
	     * creates an DrawJS Bitmap instance
	     * @memberOf Helpers
	     * @method createImage
	     * @static
	     * @param {HTMLElement} image the preloaded DOM element representing the image
	     * @return {Bitmap}
	     */
	
	  }, {
	    key: 'createImage',
	    value: function createImage(image) {
	      return new _Draw2.default.Bitmap(image);
	    }
	
	    /**
	     * creates an DrawJS Sprite instance
	     * @memberOf Helpers
	     * @method createSprite
	     * @static
	     * @param {HTMLElement} spritesheet the preloaded DOM element representing the sprite
	     * @return {Sprite}
	     */
	
	  }, {
	    key: 'createSprite',
	    value: function createSprite(spritesheet) {
	      return new _Draw2.default.Sprite(spritesheet);
	    }
	  }]);
	
	  return Helpers;
	}();
	
	exports.default = Helpers;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEs6Js = __webpack_require__(1);
	
	var draw = {
	  AlphaMapFilter: _createEs6Js.Easel.AlphaMapFilter,
	  AlphaMaskFilter: _createEs6Js.Easel.AlphaMaskFilter,
	  BlurFilter: _createEs6Js.Easel.BlurFilter,
	  ColorFilter: _createEs6Js.Easel.ColorFilter,
	  ColorMatrixFilter: _createEs6Js.Easel.ColorMatrixFilter,
	  ColorMatrix: _createEs6Js.Easel.ColorMatrix,
	  Filter: _createEs6Js.Easel.Filter,
	  Matrix2D: _createEs6Js.Easel.Matrix2D,
	  DisplayProps: _createEs6Js.Easel.DisplayProps,
	  Point: _createEs6Js.Easel.Point,
	  Rectangle: _createEs6Js.Easel.Rectangle,
	  ButtonHelper: _createEs6Js.Easel.ButtonHelper,
	  SpriteSheetBuilder: _createEs6Js.Easel.SpriteSheetBuilder,
	  SpriteSheetUtils: _createEs6Js.Easel.SpriteSheetUtils,
	  MovieClipPlugin: _createEs6Js.Easel.MovieClipPlugin,
	  Bitmap: _createEs6Js.Easel.Bitmap,
	  BitmapText: _createEs6Js.Easel.BitmapText,
	  Container: _createEs6Js.Easel.Container,
	  DisplayObject: _createEs6Js.Easel.DisplayObject,
	  DOMElement: _createEs6Js.Easel.DOMElement,
	  Graphics: _createEs6Js.Easel.Graphics,
	  MovieClip: _createEs6Js.Easel.MovieClip,
	  Shadow: _createEs6Js.Easel.Shadow,
	  Shape: _createEs6Js.Easel.Shape,
	  Sprite: _createEs6Js.Easel.Sprite,
	  SpriteContainer: _createEs6Js.Easel.SpriteContainer,
	  SpriteSheet: _createEs6Js.Easel.SpriteSheet,
	  SpriteStage: _createEs6Js.Easel.SpriteStage,
	  Stage: _createEs6Js.Easel.Stage,
	  StageGL: _createEs6Js.Easel.StageGL,
	  Text: _createEs6Js.Easel.Text
	};
	
	exports.default = draw;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEs6Js = __webpack_require__(1);
	
	var anim = {
	  CSSPlugin: _createEs6Js.Tween.CSSPlugin,
	  MotionGuidePlugin: _createEs6Js.Tween.MotionGuidePlugin,
	  Ease: _createEs6Js.Tween.Ease,
	  Timeline: _createEs6Js.Tween.Timeline,
	  Tween: _createEs6Js.Tween.Tween
	};
	
	exports.default = anim;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _TextElement2 = __webpack_require__(7);
	
	var _TextElement3 = _interopRequireDefault(_TextElement2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs a LabelElement instance
	 * @class LabelElement
	 * @classdesc the LabelElement class extends TextElement, implementing padding, minWidth, etc etc ...
	 * @extend TextElement
	 * @public
	 * @param {Object} options the options to be merged with defaults settings
	 * @type {LabelElement}
	 */
	var LabelElement = function (_TextElement) {
	  _inherits(LabelElement, _TextElement);
	
	  function LabelElement() {
	    _classCallCheck(this, LabelElement);
	
	    return _possibleConstructorReturn(this, (LabelElement.__proto__ || Object.getPrototypeOf(LabelElement)).apply(this, arguments));
	  }
	
	  _createClass(LabelElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for Label Element
	     * @memberOf LabelElement
	     * @method initDefaults
	     * @instance
	     * @override
	     * @param {Object} defaults the defaults settings
	     */
	    value: function initDefaults(defaults) {
	      _get(LabelElement.prototype.__proto__ || Object.getPrototypeOf(LabelElement.prototype), 'initDefaults', this).call(this, {
	        text: 'Label',
	        padding: 10,
	        minWidth: 0
	      }.inherit(defaults));
	    }
	
	    /**
	     * compute bounds before drawing all graphic elements of LabelElement instance
	     * @memberOf LabelElement
	     * @method computeBounds
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'computeBounds',
	    value: function computeBounds() {
	      _get(LabelElement.prototype.__proto__ || Object.getPrototypeOf(LabelElement.prototype), 'computeBounds', this).call(this);
	
	      if (!!this.settings.minWidth) {
	        if (String.isPercentage(this.settings.minWidth) && !!this.parent) {
	          this.settings.minWidth = this.parent.getComputedBounds().width * this.settings.minWidth.parsePercentage();
	        }
	
	        if (this.settings.size.width < this.settings.minWidth) {
	          this.settings.size.width = this.settings.minWidth;
	        }
	      }
	    }
	
	    /**
	     * centers the text inside LabelElement container
	     * @memberOf LabelElement
	     * @method centerText
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'centerText',
	    value: function centerText() {
	      if (!!this.settings.outline) {
	        this.textOutline.inherit({
	          x: this.settings.size.width * 0.5,
	          y: this.settings.size.height * 0.5
	        });
	      }
	
	      this.text.inherit({
	        x: this.settings.size.width * 0.5,
	        y: this.settings.size.height * 0.5
	      });
	    }
	
	    /**
	     * aligns the text inside the LabelElement container
	     * @memberOf LabelElement
	     * @method alignText
	     * @instance
	     * @override
	     * @param {String} mode can be a couple of word for horizontal or vertical align, in any order<br>
	     *   accepts the following modes<br>
	     *   <ul>
	     *     <li><b>Horizontal Modes</b>: left, center, right</li>
	     *     <li><b>Vertical Modes</b>: top, middle, bottom</li>
	     *   </ul>
	     * @return {LabelElement}
	     */
	
	  }, {
	    key: 'alignText',
	    value: function alignText() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center middle';
	
	      var modes = mode.toArray(' ');
	      var horizontalModes = ['left', 'center', 'right'];
	      var verticalModes = ['top', 'middle', 'bottom'];
	
	      var textOptions = {
	        x: this.settings.size.width * 0.5,
	        y: this.settings.size.height * 0.5,
	        textAlign: 'center',
	        textBaseline: 'middle'
	      };
	
	      if (horizontalModes.contains(modes)) {
	        if (modes.contains('left')) {
	          textOptions.inherit({
	            x: 0,
	            textAlign: 'left'
	          });
	        } else if (modes.contains('right')) {
	          textOptions.inherit({
	            x: this.settings.size.width,
	            textAlign: 'right'
	          });
	        }
	      }
	
	      if (verticalModes.contains(modes)) {
	        if (modes.contains('top')) {
	          textOptions.inherit({
	            y: 0,
	            textBaseline: 'top'
	          });
	        } else if (modes.contains('bottom')) {
	          textOptions.inherit({
	            y: this.settings.size.height,
	            textBaseline: 'bottom'
	          });
	        }
	      }
	
	      if (!!this.settings.outline) {
	        this.textOutline.inherit(textOptions);
	      }
	
	      this.text.inherit(textOptions);
	
	      return this;
	    }
	  }]);
	
	  return LabelElement;
	}(_TextElement3.default);
	
	exports.default = LabelElement;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createEs6Js = __webpack_require__(1);
	
	var _createEs6Js2 = _interopRequireDefault(_createEs6Js);
	
	var _Helpers = __webpack_require__(3);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs a TextElement instance
	 * @class TextElement
	 * @classdesc extends Element Class adding an EaselJS Text instance inside of it
	 * @extend Element
	 * @public
	 * @param {Object} options the options to be merged with defaults settings
	 * @type {TextElement}
	 */
	var TextElement = function (_Element) {
	  _inherits(TextElement, _Element);
	
	  function TextElement() {
	    _classCallCheck(this, TextElement);
	
	    return _possibleConstructorReturn(this, (TextElement.__proto__ || Object.getPrototypeOf(TextElement)).apply(this, arguments));
	  }
	
	  _createClass(TextElement, [{
	    key: 'initDefaults',
	
	    /**
	     * initializes defaults settings for TextElement
	     * @memberOf TextElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults(defaults) {
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'initDefaults', this).call(this, {
	        text: 'Text Element',
	        font: '50px Arial',
	        color: '#000',
	        padding: false,
	        lineHeight: false,
	        maxWidth: false,
	        shadow: false,
	        outline: false,
	        textAlign: 'center'
	      }.inherit(defaults));
	    }
	
	    /**
	     * initializes the settings object for the TextElement instance
	     * @memberOf TextElement
	     * @method initSettings
	     * @instance
	     * @override
	     * @param {Object} options the options to be merged with the defaults settings
	     */
	
	  }, {
	    key: 'initSettings',
	    value: function initSettings(options) {
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'initSettings', this).call(this, options);
	
	      if (!this.settings.lineHeight) {
	        this.settings.lineHeight = Number.parse(this.settings.font);
	      } else {
	        this.settings.lineHeight = Number.parse(this.settings.lineHeight);
	      }
	    }
	
	    /**
	     * computes the bounds based on specified text parameter
	     * @memberOf TextElement
	     * @method setComputedBounds
	     * @instance
	     */
	
	  }, {
	    key: 'setComputedBounds',
	    value: function setComputedBounds() {
	      var boundsOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.textBounds = !!this.settings.outline ? this.textOutline.getBounds() : this.text.getBounds();
	
	      if (!!this.settings.padding) {
	        var paddingSettings = {
	          horizontal: 0,
	          vertical: 0
	        };
	
	        if (Number.isNumber(this.settings.padding) || Array.isArray(this.settings.padding)) {
	          var paddingArray = this.settings.padding;
	
	          if (Number.isNumber(this.settings.padding)) {
	            paddingArray = [this.settings.padding, this.settings.padding];
	          }
	
	          this.settings.padding = {
	            horizontal: paddingArray[0],
	            vertical: paddingArray[1]
	          };
	        }
	
	        if (this.settings.padding.horizontal > 0) {
	          this.textBounds.inherit({
	            width: this.textBounds.width + this.settings.padding.horizontal
	          });
	        }
	
	        if (this.settings.padding.vertical > 0) {
	          this.textBounds.inherit({
	            height: this.textBounds.height + this.settings.padding.vertical
	          });
	        }
	      }
	
	      this.settings.inherit({
	        size: {
	          width: this.textBounds.width,
	          height: this.textBounds.height
	        }
	      });
	
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'setComputedBounds', this).call(this, this.settings.size);
	    }
	  }, {
	    key: 'preDrawElement',
	    value: function preDrawElement() {
	      if (!!this.settings.outline) {
	        this.textOutline = _Helpers2.default.createText(this.settings.text, this.settings.font, this.settings.outline.color).inherit({
	          textAlign: this.settings.textAlign,
	          textBaseline: 'middle',
	          lineHeight: this.settings.lineHeight || null,
	          lineWidth: this.settings.maxWidth || null,
	          outline: this.settings.outline.size,
	          shadow: !!this.settings.shadow ? new (Function.prototype.bind.apply(_createEs6Js2.default.Shadow, [null].concat(_toConsumableArray(this.settings.shadow))))() : null
	        });
	      }
	
	      this.text = _Helpers2.default.createText(this.settings.text, this.settings.font, this.settings.color).inherit({
	        textAlign: this.settings.textAlign,
	        textBaseline: 'middle',
	        lineHeight: this.settings.lineHeight || null,
	        lineWidth: this.settings.maxWidth || null,
	        shadow: !!this.settings.shadow ? new (Function.prototype.bind.apply(_createEs6Js2.default.Shadow, [null].concat(_toConsumableArray(this.settings.shadow))))() : null
	      });
	
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'preDrawElement', this).call(this);
	    }
	  }, {
	    key: 'setScale',
	    value: function setScale() {
	      var scaleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'setScale', this).call(this, scaleOptions, force);
	
	      if (!!this.settings.outline) {
	        this.textOutline.inherit({
	          scaleX: this.settings.scale.x,
	          scaleY: this.settings.scale.y
	        });
	      }
	
	      this.text.inherit({
	        scaleX: this.settings.scale.x,
	        scaleY: this.settings.scale.y
	      });
	    }
	    /**
	     * draws all graphic elements of the TextElement instance
	     * @memberOf TextElement
	     * @method drawElements
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'drawElements', this).call(this);
	
	      if (!!this.settings.outline) {
	        this.addChild(this.textOutline);
	      }
	
	      this.addChild(this.text);
	    }
	  }, {
	    key: 'alignTextObject',
	    value: function alignTextObject() {
	      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
	
	      if (!!text) {
	        text.inherit({
	          textAlign: mode
	        });
	
	        if (mode === 'center') {
	          text.inherit({
	            x: text.getBounds().width * 0.5 * this.settings.scale.x
	          });
	        } else if (mode === 'right') {
	          text.inherit({
	            x: text.getBounds().width * this.settings.scale.x
	          });
	        }
	
	        text.inherit({
	          y: this.settings.lineHeight * 0.5 * this.settings.scale.y
	        });
	
	        if (!!this.settings.padding) {
	          text.inherit({
	            x: text.x + this.settings.padding.horizontal * 0.5 * this.settings.scale.x,
	            y: text.y + this.settings.padding.vertical * 0.5 * this.settings.scale.y
	          });
	        }
	      }
	    }
	  }, {
	    key: 'alignText',
	    value: function alignText() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
	
	      if (!!this.settings.outline) {
	        this.alignTextObject(this.textOutline, mode);
	      }
	
	      this.alignTextObject(this.text, mode);
	    }
	  }, {
	    key: 'postDrawElement',
	    value: function postDrawElement() {
	      _get(TextElement.prototype.__proto__ || Object.getPrototypeOf(TextElement.prototype), 'postDrawElement', this).call(this);
	
	      this.alignText(this.settings.textAlign);
	    }
	
	    /**
	     * gets the actual text content
	     * @memberOf TextElement
	     * @method getText
	     * @instance
	     * @return {String}
	     */
	
	  }, {
	    key: 'getText',
	    value: function getText() {
	      return this.text.text;
	    }
	
	    /**
	     * sets the text content for the TextElement instance, considering also the textOutline
	     * @memberOf TextElement
	     * @method setText
	     * @instance
	     * @param {String} text the text content
	     * @return {TextElement} to make chainable the method
	     */
	
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      if (!!this.settings.outline) {
	        this.textOutline.text = text;
	      }
	
	      this.text.text = text;
	
	      return this;
	    }
	  }]);
	
	  return TextElement;
	}(_Element3.default);
	
	exports.default = TextElement;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoxElement = exports.SpriteElement = exports.ImageElement = exports.ListElement = exports.ListItemElement = exports.ButtonElement = exports.LabelElement = exports.TextElement = exports.Element = exports.StageElement = exports.Helpers = undefined;
	
	var _Helpers = __webpack_require__(3);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	var _StageElement = __webpack_require__(20);
	
	var _StageElement2 = _interopRequireDefault(_StageElement);
	
	var _Element = __webpack_require__(2);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _TextElement = __webpack_require__(7);
	
	var _TextElement2 = _interopRequireDefault(_TextElement);
	
	var _LabelElement = __webpack_require__(6);
	
	var _LabelElement2 = _interopRequireDefault(_LabelElement);
	
	var _ButtonElement = __webpack_require__(10);
	
	var _ButtonElement2 = _interopRequireDefault(_ButtonElement);
	
	var _ListItemElement = __webpack_require__(12);
	
	var _ListItemElement2 = _interopRequireDefault(_ListItemElement);
	
	var _ListElement = __webpack_require__(18);
	
	var _ListElement2 = _interopRequireDefault(_ListElement);
	
	var _ImageElement = __webpack_require__(11);
	
	var _ImageElement2 = _interopRequireDefault(_ImageElement);
	
	var _SpriteElement = __webpack_require__(19);
	
	var _SpriteElement2 = _interopRequireDefault(_SpriteElement);
	
	var _BoxElement = __webpack_require__(17);
	
	var _BoxElement2 = _interopRequireDefault(_BoxElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module Elements
	 * @description The Elements module of CreateJS Core Framework
	 * @property {Helpers} Helpers all the helpers we need to draw the elements
	 * @property {StageElement} StageElement
	 * @property {Element} Element
	 * @property {TextElement} TextElement
	 * @property {LabelElement} LabelElement
	 * @property {ButtonElement} ButtonElement
	 * @property {ListItemElement} ListItemElement
	 * @property {ListElement} ListElement
	 * @property {ImageElement} ImageElement
	 * @property {SpriteElement} SpriteElement
	 * @property {BoxElement} BoxElement
	 */
	
	var Elements = {
	  Helpers: _Helpers2.default,
	  StageElement: _StageElement2.default,
	  Element: _Element2.default,
	  TextElement: _TextElement2.default,
	  LabelElement: _LabelElement2.default,
	  ButtonElement: _ButtonElement2.default,
	  ListItemElement: _ListItemElement2.default,
	  ListElement: _ListElement2.default,
	  ImageElement: _ImageElement2.default,
	  SpriteElement: _SpriteElement2.default,
	  BoxElement: _BoxElement2.default
	};
	
	exports.default = Elements;
	exports.Helpers = _Helpers2.default;
	exports.StageElement = _StageElement2.default;
	exports.Element = _Element2.default;
	exports.TextElement = _TextElement2.default;
	exports.LabelElement = _LabelElement2.default;
	exports.ButtonElement = _ButtonElement2.default;
	exports.ListItemElement = _ListItemElement2.default;
	exports.ListElement = _ListElement2.default;
	exports.ImageElement = _ImageElement2.default;
	exports.SpriteElement = _SpriteElement2.default;
	exports.BoxElement = _BoxElement2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEs6Js = __webpack_require__(1);
	
	var core = {
	  EventDispatcher: _createEs6Js.Core.EventDispatcher,
	  Event: _createEs6Js.Core.Event,
	  ErrorEvent: _createEs6Js.Core.ErrorEvent,
	  MouseEvent: _createEs6Js.Core.MouseEvent,
	  ProgressEvent: _createEs6Js.Core.ProgressEvent,
	  BrowserDetect: _createEs6Js.Core.BrowserDetect,
	  Ticker: _createEs6Js.Core.Ticker,
	  Touch: _createEs6Js.Core.Touch,
	  UID: _createEs6Js.Core.UID,
	  extend: _createEs6Js.Core.extend,
	  indexOf: _createEs6Js.Core.indexOf,
	  promote: _createEs6Js.Core.promote
	};
	
	exports.default = core;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _LabelElement2 = __webpack_require__(6);
	
	var _LabelElement3 = _interopRequireDefault(_LabelElement2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs a ButtonElement instance
	 * @class ButtonElement
	 * @classdesc Button Element class, extending LabelElement with a click event handler
	 * @extends LabelElement
	 * @param {Object} options the options object to be merged with defaults
	 * @type {ButtonElement}
	 * @public
	 */
	var ButtonElement = function (_LabelElement) {
	  _inherits(ButtonElement, _LabelElement);
	
	  function ButtonElement() {
	    _classCallCheck(this, ButtonElement);
	
	    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
	  }
	
	  _createClass(ButtonElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for Button Element
	     * @memberOf ButtonElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults(defaults) {
	      _get(ButtonElement.prototype.__proto__ || Object.getPrototypeOf(ButtonElement.prototype), 'initDefaults', this).call(this, {
	        text: 'Button',
	        stroke: {
	          size: 4,
	          radius: 5,
	          color: '#fff'
	        },
	        events: {
	          click: function click() {}
	        }
	      }.inherit(defaults));
	    }
	  }]);
	
	  return ButtonElement;
	}(_LabelElement3.default);
	
	exports.default = ButtonElement;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Helpers = __webpack_require__(3);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs an ImageElement instance
	 * @class ImageElement
	 * @classdesc ImageElement class, extending Element
	 * @extends Element
	 * @param {Object} options the options object to be merged with defaults
	 * @type {ImageElement}
	 * @public
	 */
	var ImageElement = function (_Element) {
	  _inherits(ImageElement, _Element);
	
	  function ImageElement() {
	    _classCallCheck(this, ImageElement);
	
	    return _possibleConstructorReturn(this, (ImageElement.__proto__ || Object.getPrototypeOf(ImageElement)).apply(this, arguments));
	  }
	
	  _createClass(ImageElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for ImageElement
	     * @memberOf ImageElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults() {
	      _get(ImageElement.prototype.__proto__ || Object.getPrototypeOf(ImageElement.prototype), 'initDefaults', this).call(this, {
	        image: null
	      });
	    }
	
	    /**
	     * sets or updates the scaling of the Element instance
	     * @memberOf Element
	     * @method setScale
	     * @instance
	     * @param {Object|Number} scaleOptions can be an object with x and y couple or only a number to be used for both
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setScale',
	    value: function setScale() {
	      var scaleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _get(ImageElement.prototype.__proto__ || Object.getPrototypeOf(ImageElement.prototype), 'setScale', this).call(this, scaleOptions, force);
	
	      this.image.inherit({
	        scaleX: this.scaleX,
	        scaleY: this.scaleY
	      });
	
	      return this;
	    }
	  }, {
	    key: 'preDrawElement',
	    value: function preDrawElement() {
	      this.image = _Helpers2.default.createImage(this.settings.image);
	      this.imageBounds = this.image.getBounds();
	
	      this.image.inherit({
	        regX: this.imageBounds.width * 0.5,
	        regY: this.imageBounds.height * 0.5
	      });
	
	      if (!this.settings.size.force) {
	        this.settings.inherit({
	          size: {
	            width: this.imageBounds.width,
	            height: this.imageBounds.height
	          }
	        });
	      }
	
	      _get(ImageElement.prototype.__proto__ || Object.getPrototypeOf(ImageElement.prototype), 'preDrawElement', this).call(this);
	    }
	
	    /**
	     * draws all graphic elements of the ImageElement instance
	     * @memberOf ImageElement
	     * @method drawElements
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      _get(ImageElement.prototype.__proto__ || Object.getPrototypeOf(ImageElement.prototype), 'drawElements', this).call(this);
	
	      this.addChild(this.image);
	      _Helpers2.default.align(this.image, null, 'center middle', true);
	    }
	  }]);
	
	  return ImageElement;
	}(_Element3.default);
	
	exports.default = ImageElement;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ButtonElement2 = __webpack_require__(10);
	
	var _ButtonElement3 = _interopRequireDefault(_ButtonElement2);
	
	var _ImageElement = __webpack_require__(11);
	
	var _ImageElement2 = _interopRequireDefault(_ImageElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs a ListItemElement instance
	 * @class ListItemElement
	 * @classdesc the ListItemElement extends ButtonElement allowing you to add a list item indicator and a text, with a click event handler
	 * @extend ButtonElement
	 * @param {Object} options the options object to be merged with defaults
	 * @type {ListItemElement}
	 * @public
	 */
	var ListItemElement = function (_ButtonElement) {
	  _inherits(ListItemElement, _ButtonElement);
	
	  function ListItemElement() {
	    _classCallCheck(this, ListItemElement);
	
	    return _possibleConstructorReturn(this, (ListItemElement.__proto__ || Object.getPrototypeOf(ListItemElement)).apply(this, arguments));
	  }
	
	  _createClass(ListItemElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for ListItemElement instance
	     * @memberOf ListItemElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults() {
	      _get(ListItemElement.prototype.__proto__ || Object.getPrototypeOf(ListItemElement.prototype), 'initDefaults', this).call(this, {
	        text: 'List Item',
	        indicator: false, // options for an ImageElement to use as listItem indicator
	        stroke: {
	          size: 0,
	          radius: 0,
	          color: 'transparent'
	        },
	        events: {
	          click: function click() {}
	        }
	      });
	    }
	
	    /**
	     * draws all graphic elements of the ListItemElement instance
	     * @memberOf ListItemElement
	     * @method drawElements
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      if (!!this.settings.indicator) {
	        this.indicator = new _ImageElement2.default(this.settings.indicator.inherit({
	          parent: this,
	          align: 'left middle'
	        })).setPosition({
	          x: 10
	        });
	
	        this.settings.lineHeight = this.indicator.getComputedBounds().height;
	      }
	
	      this.alignText('left middle');
	      this.setTextPosition({
	        x: this.indicator.getComputedBounds().right + 10
	      }, true);
	    }
	  }]);
	
	  return ListItemElement;
	}(_ButtonElement3.default);
	
	exports.default = ListItemElement;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  version: '0.1.21',
	  build: new Date()
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Elements = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_Element) {
	  _inherits(Component, _Element);
	
	  function Component() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Component);
	
	    return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, options));
	  }
	
	  _createClass(Component, [{
	    key: 'initDefaults',
	    value: function initDefaults(defaults) {
	      _get(Component.prototype.__proto__ || Object.getPrototypeOf(Component.prototype), 'initDefaults', this).call(this, {}.inherit(defaults));
	    }
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      _get(Component.prototype.__proto__ || Object.getPrototypeOf(Component.prototype), 'drawElements', this).call(this);
	    }
	  }]);
	
	  return Component;
	}(_Elements.Element);
	
	exports.default = Component;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Elements = __webpack_require__(8);
	
	var _Anim = __webpack_require__(5);
	
	var _Anim2 = _interopRequireDefault(_Anim);
	
	var _Component2 = __webpack_require__(14);
	
	var _Component3 = _interopRequireDefault(_Component2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressBar = function (_Component) {
	  _inherits(ProgressBar, _Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
	  }
	
	  _createClass(ProgressBar, [{
	    key: 'setProgress',
	    value: function setProgress(percentage) {
	      var _this2 = this;
	
	      return new Promise(function (resolve) {
	        _Anim2.default.Tween.get(_this2.progress).to({
	          x: _this2.progressStartX + _this2.progressBounds.width * percentage
	        }, 250).call(function () {
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: 'initDefaults',
	    value: function initDefaults(defaults) {
	      _get(ProgressBar.prototype.__proto__ || Object.getPrototypeOf(ProgressBar.prototype), 'initDefaults', this).call(this, {
	        fill: '#fff',
	        padding: [10, 10],
	        stroke: {
	          size: 4,
	          color: '#000',
	          radius: 50
	        },
	        size: {
	          width: 150,
	          height: 50
	        }
	      }.inherit(defaults));
	    }
	  }, {
	    key: 'initSettings',
	    value: function initSettings(options) {
	      var parsedOptions = options;
	
	      if (Number.isNumber(parsedOptions.padding)) {
	        parsedOptions.padding = [parsedOptions.padding, parsedOptions.padding];
	      }
	
	      _get(ProgressBar.prototype.__proto__ || Object.getPrototypeOf(ProgressBar.prototype), 'initSettings', this).call(this, parsedOptions);
	    }
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      var _progress;
	
	      _get(ProgressBar.prototype.__proto__ || Object.getPrototypeOf(ProgressBar.prototype), 'drawElements', this).call(this);
	
	      this.progressBounds = {
	        width: this.getComputedBounds().width - this.settings.padding[0],
	        height: this.getComputedBounds().height - this.settings.padding[1]
	      };
	
	      this.progressMask = new _Elements.Element({
	        fill: '#000',
	        stroke: {
	          size: 0,
	          radius: this.settings.stroke.radius
	        },
	        size: this.progressBounds
	      }).children.first().inherit({
	        x: this.progressMask.x + this.settings.padding[0] / 2,
	        y: this.progressMask.y + this.settings.padding[1] / 2
	      });
	
	      this.progress = new _Elements.Element({
	        parent: this,
	        fill: {
	          colors: ['rgb(254, 127, 200)', 'rgb(171, 27, 190)'],
	          ratios: [0, 1],
	          points: [0, 15, 0, 45]
	        },
	        stroke: {
	          size: 0,
	          radius: this.settings.stroke.radius
	        },
	        mask: this.progressMask,
	        size: this.progressBounds,
	        align: 'center middle'
	      }).setPosition({
	        x: -this.progressBounds.width
	      });
	
	      this.progressStartX = this.progress.getComputedBounds().x;
	
	      (_progress = this.progress).cache.apply(_progress, _toConsumableArray(this.progress.bounds));
	    }
	  }]);
	
	  return ProgressBar;
	}(_Component3.default);
	
	exports.default = ProgressBar;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProgressBar = __webpack_require__(15);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = {
	  ProgressBar: _ProgressBar2.default
	};
	
	exports.default = components;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _LabelElement = __webpack_require__(6);
	
	var _LabelElement2 = _interopRequireDefault(_LabelElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs a BoxElement instance
	 * @class BoxElement
	 * @classdesc Box Element class, useful to create boxes with a title options (LabelElement)
	 * @extends Element
	 * @param {Object} options the options object to be merged with defaults
	 * @type {BoxElement}
	 * @public
	 */
	var BoxElement = function (_Element) {
	  _inherits(BoxElement, _Element);
	
	  function BoxElement() {
	    _classCallCheck(this, BoxElement);
	
	    return _possibleConstructorReturn(this, (BoxElement.__proto__ || Object.getPrototypeOf(BoxElement)).apply(this, arguments));
	  }
	
	  _createClass(BoxElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for Box Element
	     * @memberOf BoxElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults() {
	      _get(BoxElement.prototype.__proto__ || Object.getPrototypeOf(BoxElement.prototype), 'initDefaults', this).call(this, {
	        title: { // options for a LabelElement
	          text: 'Text Element',
	          font: '50px Arial',
	          color: '#000',
	          padding: 10,
	          lineHeight: 50,
	          maxWidth: false,
	          shadow: false,
	          outline: false,
	          stroke: false,
	          align: 'center top'
	        },
	        content: { // options for a Element
	          fill: 'transparent',
	          align: 'center bottom'
	        }
	      });
	    }
	
	    /**
	     * drawElements method implementation
	     * @memberOf BoxElement
	     * @method drawElements
	     * @instance
	     * @inheritdoc
	     * @override
	     */
	
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      if (!!this.settings.title) {
	        this.titleElement = new _LabelElement2.default(this.settings.title.inherit({
	          parent: this,
	          minWidth: this.settings.size.width
	        }));
	      }
	
	      this.contentElement = new _Element3.default(this.settings.content.inherit({
	        parent: this,
	        size: {
	          width: this.settings.size.width,
	          height: this.settings.size.height - (!!this.settings.title ? this.titleElement.getComputedBounds().height : 0)
	        }
	      }));
	    }
	
	    /**
	     * gets the title LabelElement instance
	     * @memberOf BoxElement
	     * @method getTitleElement
	     * @instance
	     * @return {LabelElement} the instance used to draw the title
	     */
	
	  }, {
	    key: 'getTitleElement',
	    value: function getTitleElement() {
	      return this.titleElement;
	    }
	
	    /**
	     * gets the content Element instance
	     * @memberOf BoxElement
	     * @method getContentElement
	     * @instance
	     * @return {Element} the instance used to draw the content element
	     */
	
	  }, {
	    key: 'getContentElement',
	    value: function getContentElement() {
	      return this.contentElement;
	    }
	  }]);
	
	  return BoxElement;
	}(_Element3.default);
	
	exports.default = BoxElement;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _ListItemElement = __webpack_require__(12);
	
	var _ListItemElement2 = _interopRequireDefault(_ListItemElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs a ListElement instance
	 * @class ListElement
	 * @classdesc the ListElement class allows to create a list of any type of elements
	 * @extend Element
	 * @public
	 * @param {Object} options the options to be merged with defaults settings
	 * @type {ListElement}
	 */
	var ListElement = function (_Element) {
	  _inherits(ListElement, _Element);
	
	  function ListElement() {
	    _classCallCheck(this, ListElement);
	
	    return _possibleConstructorReturn(this, (ListElement.__proto__ || Object.getPrototypeOf(ListElement)).apply(this, arguments));
	  }
	
	  _createClass(ListElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for List Element
	     * @memberOf ListElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults() {
	      _get(ListElement.prototype.__proto__ || Object.getPrototypeOf(ListElement.prototype), 'initDefaults', this).call(this, {
	        items: [],
	        item: { // options for a ListItemElement to use as default listItem options
	          minWidth: '100%',
	          color: '#fff'
	        },
	        itemEvents: { // event handlers to use as default listItem event handlers
	          click: function click() {}
	        },
	        indicator: false, // options for an ImageElement to use as default listItem indicator
	        stroke: {
	          size: 0,
	          radius: 0,
	          color: 'transparent'
	        }
	      });
	    }
	
	    /**
	     * initializes data object for the ListElement instance
	     * @memberOf ListElement
	     * @method initData
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'initData',
	    value: function initData() {
	      this.items = [];
	    }
	
	    /**
	     * compute bounds before drawing all graphic elements of ListElement instance
	     * @memberOf ListElement
	     * @method computeBounds
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'computeBounds',
	    value: function computeBounds() {
	      if (!!this.settings.minWidth) {
	        if (this.settings.minWidth.isPercentage() && !!this.parent) {
	          this.settings.minWidth = this.parent.getComputedBounds().width * this.settings.minWidth.parsePercentage();
	        }
	
	        if (this.settings.size.width < this.settings.minWidth) {
	          this.settings.size.width = this.settings.minWidth;
	        }
	      }
	    }
	  }, {
	    key: 'preDrawElement',
	    value: function preDrawElement() {
	      this.computeBounds();
	
	      _get(ListElement.prototype.__proto__ || Object.getPrototypeOf(ListElement.prototype), 'preDrawElement', this).call(this);
	    }
	
	    /**
	     * draws all graphic elements of the ListElement instance, cycles the items, draw them and computes positions
	     * @memberOf ListElement
	     * @method drawElements
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      var _this2 = this;
	
	      _get(ListElement.prototype.__proto__ || Object.getPrototypeOf(ListElement.prototype), 'drawElements', this).call(this);
	
	      this.settings.path('items', []).each(function (item, i) {
	        var listItem = new _ListItemElement2.default(_this2.settings.item.inherit(true, {
	          indicator: _this2.settings.indicator,
	          events: _this2.settings.itemEvents
	        }, item, {
	          parent: _this2,
	          align: 'left top'
	        }));
	
	        _this2.items.push(listItem);
	
	        if (i > 0) {
	          listItem.setPosition({
	            y: _this2.items[i - 1].getComputedBounds().bottom
	          });
	        }
	      });
	    }
	  }]);
	
	  return ListElement;
	}(_Element3.default);
	
	exports.default = ListElement;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Helpers = __webpack_require__(3);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs an SpriteElement instance
	 * @class SpriteElement
	 * @classdesc SpriteElement class, extending Element
	 * @extends Element
	 * @param {Object} options the options object to be merged with defaults
	 * @type {SpriteElement}
	 * @public
	 */
	var SpriteElement = function (_Element) {
	  _inherits(SpriteElement, _Element);
	
	  function SpriteElement() {
	    _classCallCheck(this, SpriteElement);
	
	    return _possibleConstructorReturn(this, (SpriteElement.__proto__ || Object.getPrototypeOf(SpriteElement)).apply(this, arguments));
	  }
	
	  _createClass(SpriteElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for SpriteElement
	     * @memberOf SpriteElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults() {
	      _get(SpriteElement.prototype.__proto__ || Object.getPrototypeOf(SpriteElement.prototype), 'initDefaults', this).call(this, {
	        spritesheet: null
	      });
	    }
	
	    /**
	     * sets or updates the scaling of the Element instance
	     * @memberOf Element
	     * @method setScale
	     * @instance
	     * @param {Object|Number} scaleOptions can be an object with x and y couple or only a number to be used for both
	     * @return {Element} to make chainable the method
	     */
	
	  }, {
	    key: 'setScale',
	    value: function setScale() {
	      var scaleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _get(SpriteElement.prototype.__proto__ || Object.getPrototypeOf(SpriteElement.prototype), 'setScale', this).call(this, scaleOptions, force);
	
	      this.sprite.inherit({
	        scaleX: this.scaleX,
	        scaleY: this.scaleY
	      });
	
	      return this;
	    }
	  }, {
	    key: 'preDrawElement',
	    value: function preDrawElement() {
	      this.sprite = _Helpers2.default.createSprite(this.settings.spritesheet);
	      this.sprite.setBounds(0, 0, this.sprite.getBounds().width, this.sprite.getBounds().height);
	      this.spriteBounds = this.sprite.getBounds();
	
	      this.sprite.inherit({
	        regX: this.spriteBounds.width * 0.5,
	        regY: this.spriteBounds.height * 0.5
	      });
	
	      if (!this.settings.size.force) {
	        this.settings.inherit({
	          size: {
	            width: this.spriteBounds.width,
	            height: this.spriteBounds.height
	          }
	        });
	      }
	
	      _get(SpriteElement.prototype.__proto__ || Object.getPrototypeOf(SpriteElement.prototype), 'preDrawElement', this).call(this);
	    }
	    /**
	     * draws all graphic elements of the SpriteElement instance
	     * @memberOf SpriteElement
	     * @method drawElements
	     * @instance
	     * @override
	     */
	
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      _get(SpriteElement.prototype.__proto__ || Object.getPrototypeOf(SpriteElement.prototype), 'drawElements', this).call(this);
	
	      this.addChild(this.sprite);
	      _Helpers2.default.align(this.sprite, null, 'center middle', false);
	    }
	
	    /**
	     * animates the sprite
	     * @memberOf SpriteElement
	     * @method animate
	     * @instance
	     * @param {Object} options the animate options including<br>
	     * @param {String} options.animationName the animation name in the spritesheet json to start
	     * @param {Function}
	     * @return {SpriteElement}
	     */
	
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (Object.isObject(options)) {
	        if (!!options.animationName) {
	          if (!!options.onAnimationEnd) {
	            if (Function.isFunction(options.onAnimationEnd)) {
	              this.sprite.on('animationend', options.onAnimationEnd);
	            }
	          }
	
	          this.sprite.gotoAndPlay(options.animationName);
	        }
	      }
	
	      return this;
	    }
	  }]);
	
	  return SpriteElement;
	}(_Element3.default);
	
	exports.default = SpriteElement;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Core = __webpack_require__(9);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	var _Draw = __webpack_require__(4);
	
	var _Draw2 = _interopRequireDefault(_Draw);
	
	var _Helpers = __webpack_require__(3);
	
	var _Helpers2 = _interopRequireDefault(_Helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageElement = function (_Draw$Stage) {
	  _inherits(StageElement, _Draw$Stage);
	
	  function StageElement() {
	    var canvas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, StageElement);
	
	    var _this = _possibleConstructorReturn(this, (StageElement.__proto__ || Object.getPrototypeOf(StageElement)).call(this, canvas));
	
	    _this.initDefaults();
	    _this.initSettings(options);
	
	    _this.init();
	    return _this;
	  }
	
	  _createClass(StageElement, [{
	    key: 'initDefaults',
	    value: function initDefaults() {
	      this.inherit({
	        defaults: {
	          enableDOMEvents: false,
	          enableMouseOverEvents: true,
	          enableTouchEvents: true,
	          enableSnapToPixel: true,
	          size: {
	            width: 0,
	            height: 0
	          }
	        }
	      });
	    }
	  }, {
	    key: 'initSettings',
	    value: function initSettings(options) {
	      this.inherit({
	        settings: this.defaults.inherit(true, options)
	      });
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      if (!!this.settings.size) {
	        this.setBounds(0, 0, this.settings.size.width, this.settings.size.height);
	      }
	
	      if (!!this.settings.enableDOMEvents) {
	        this.enableDOMEvents();
	      }
	
	      if (!!this.settings.enableMouseOverEvents) {
	        this.enableMouseOver();
	      }
	
	      if (!!this.settings.enableTouchEvents) {
	        _Core2.default.Touch.enable(this);
	      }
	
	      if (!!this.settings.enableSnapToPixel) {
	        this.snapToPixelEnabled = true;
	      }
	    }
	  }, {
	    key: 'getComputedBounds',
	    value: function getComputedBounds() {
	      return this.getBounds();
	    }
	  }, {
	    key: 'screenshot',
	    value: function screenshot() {
	      var backgroundColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transparent';
	      var mimeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/png';
	
	      return this.toDataURL(backgroundColor, mimeType);
	    }
	  }]);
	
	  return StageElement;
	}(_Draw2.default.Stage);
	
	exports.default = StageElement;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createEs6Js = __webpack_require__(1);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _TextElement = __webpack_require__(7);
	
	var _TextElement2 = _interopRequireDefault(_TextElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * constructs the preloader and returns a promise
	 * @class Preloader
	 * @classdesc the game preload class used for loading content
	 * @public
	 */
	var PreloaderElement = function (_Element) {
	  _inherits(PreloaderElement, _Element);
	
	  function PreloaderElement() {
	    _classCallCheck(this, PreloaderElement);
	
	    return _possibleConstructorReturn(this, (PreloaderElement.__proto__ || Object.getPrototypeOf(PreloaderElement)).apply(this, arguments));
	  }
	
	  _createClass(PreloaderElement, [{
	    key: 'initDefaults',
	
	    /**
	     * Initialize default settings for Button Element
	     * @memberOf ButtonElement
	     * @method initDefaults
	     * @instance
	     * @override
	     */
	    value: function initDefaults(defaults) {
	      _get(PreloaderElement.prototype.__proto__ || Object.getPrototypeOf(PreloaderElement.prototype), 'initDefaults', this).call(this, {
	        size: '100%',
	        fill: 'lightgreen',
	        align: 'center top',
	        manifests: {
	          preloader: {
	            images: [],
	            spritesheets: [],
	            sounds: []
	          },
	          game: {
	            images: [],
	            spritesheets: [],
	            sounds: []
	          }
	        }
	      }.inherit(defaults));
	    }
	  }, {
	    key: 'initData',
	    value: function initData() {
	      _get(PreloaderElement.prototype.__proto__ || Object.getPrototypeOf(PreloaderElement.prototype), 'initData', this).call(this);
	
	      this.data.inherit({
	        manifests: {
	          preloader: this.getManifest('preloader'),
	          game: this.getManifest('game')
	        },
	        progress: 0
	      });
	
	      this.assets = {
	        preloader: {
	          images: {},
	          spritesheets: {},
	          sounds: {}
	        },
	        game: {
	          images: {},
	          spritesheets: {},
	          sounds: {}
	        }
	      };
	    }
	  }, {
	    key: 'onPreloaderAssetFileError',
	    value: function onPreloaderAssetFileError(e) {
	      console.warn('Preloader Asset File Error ', e.title);
	      console.log('Preloader Asset File Error ', e);
	    }
	  }, {
	    key: 'onPreloaderAssetFileLoad',
	    value: function onPreloaderAssetFileLoad(e) {
	      // console.log('Preloader Asset File Loaded', e);
	
	      this.assets.preloader[e.item.type + 's'][e.item.id] = e.result;
	
	      if (e.item.type === 'sound') {
	        _createEs6Js.Sound.Sound.registerSound(e.item.src, e.item.id);
	      }
	    }
	  }, {
	    key: 'onPreloaderAssetsProgress',
	    value: function onPreloaderAssetsProgress(e) {
	      // console.log('Preloader Assets Progress', e);
	    }
	  }, {
	    key: 'onPreloaderAssetsComplete',
	    value: function onPreloaderAssetsComplete(e) {}
	    // console.log('Preloader Assets Complete', e);
	
	
	    /**
	       * sets up game loader. Resolve promise when loading is complete.
	       * @memberOf Preloader
	       * @method init
	       * @instance
	       * @param {Function} resolve - resolve function of the constructor Promise
	       */
	
	  }, {
	    key: 'preInit',
	    value: function preInit(options) {
	      _get(PreloaderElement.prototype.__proto__ || Object.getPrototypeOf(PreloaderElement.prototype), 'preInit', this).call(this, options);
	
	      this.preloadQueue = new _createEs6Js.Preload.LoadQueue();
	      this.preloadQueue.installPlugin(_createEs6Js.Sound.Sound);
	
	      this.preloadQueue.on('error', this.onPreloaderAssetFileError.bind(this));
	      this.preloadQueue.on('fileload', this.onPreloaderAssetFileLoad.bind(this));
	      this.preloadQueue.on('progress', this.onPreloaderAssetsProgress.bind(this));
	      this.preloadQueue.on('complete', this.onPreloaderAssetsComplete.bind(this));
	
	      this.preloadQueue.loadManifest(this.data.manifests.preloader);
	    }
	  }, {
	    key: 'drawElements',
	    value: function drawElements() {
	      _get(PreloaderElement.prototype.__proto__ || Object.getPrototypeOf(PreloaderElement.prototype), 'drawElements', this).call(this);
	
	      this.text = new _TextElement2.default({
	        parent: this,
	        text: 'Loading... 0%',
	        font: '50px Verdana',
	        align: 'center middle'
	      });
	    }
	  }, {
	    key: 'onGameAssetFileError',
	    value: function onGameAssetFileError(e) {
	      console.warn('Game Asset File Error ', e.title);
	      console.log('Game Asset File Error ', e);
	    }
	  }, {
	    key: 'onGameAssetFileLoad',
	    value: function onGameAssetFileLoad(e) {
	      this.assets.game[e.item.type + 's'][e.item.id] = e.result;
	
	      if (e.item.type === 'sound') {
	        console.log('sound registered ', e.item.id);
	        _createEs6Js.Sound.Sound.registerSound(e.item.src, e.item.id);
	      }
	    }
	  }, {
	    key: 'onGameAssetsProgress',
	    value: function onGameAssetsProgress(e) {
	      var progress = Math.round(this.loadQueue.progress * 100);
	
	      if (progress <= 100) {
	        console.log('Game Assets Progress ' + progress + '%');
	
	        if (this.data.progress < progress && progress <= 100) {
	          this.data.progress = progress;
	          this.text.setText('Loading... ' + this.data.progress + '%');
	        }
	      }
	    }
	  }, {
	    key: 'onGameAssetsComplete',
	    value: function onGameAssetsComplete(e) {
	      this.dispatchEvent({
	        type: 'preloader.preloaded',
	        assets: this.assets.game
	      });
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      _get(PreloaderElement.prototype.__proto__ || Object.getPrototypeOf(PreloaderElement.prototype), 'init', this).call(this);
	
	      this.loadQueue = new _createEs6Js.Preload.LoadQueue(false);
	      this.loadQueue.installPlugin(_createEs6Js.Sound.Sound);
	
	      this.loadQueue.on('error', this.onGameAssetFileError.bind(this));
	      this.loadQueue.on('fileload', this.onGameAssetFileLoad.bind(this));
	      this.loadQueue.on('progress', this.onGameAssetsProgress.bind(this));
	      this.loadQueue.on('complete', this.onGameAssetsComplete.bind(this));
	
	      this.loadQueue.loadManifest(this.data.manifests.game);
	    }
	  }, {
	    key: 'postInit',
	    value: function postInit() {}
	  }, {
	    key: 'getManifest',
	    value: function getManifest() {
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'game';
	
	      return this.settings.manifests[type].images.map(function (image) {
	        return image.inherit({
	          type: 'image'
	        });
	      }).concat(this.settings.manifests[type].spritesheets.map(function (spritesheet) {
	        return spritesheet.inherit({
	          type: 'spritesheet'
	        });
	      })).concat(this.settings.manifests[type].sounds.map(function (sound) {
	        return sound.inherit({
	          type: 'sound'
	        });
	      }));
	    }
	  }]);
	
	  return PreloaderElement;
	}(_Element3.default);
	
	exports.default = PreloaderElement;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEs6Js = __webpack_require__(1);
	
	var _PreloaderElement = __webpack_require__(21);
	
	var _PreloaderElement2 = _interopRequireDefault(_PreloaderElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preload = {
	  DataUtils: _createEs6Js.Preload.DataUtils,
	  DOMUtils: _createEs6Js.Preload.DOMUtils,
	  ElementsUtils: _createEs6Js.Preload.ElementsUtils,
	  RequestUtils: _createEs6Js.Preload.RequestUtils,
	  URLUtils: _createEs6Js.Preload.URLUtils,
	  AbstractLoader: _createEs6Js.Preload.AbstractLoader,
	  AbstractMediaLoader: _createEs6Js.Preload.AbstractMediaLoader,
	  BinaryLoader: _createEs6Js.Preload.BinaryLoader,
	  CSSLoader: _createEs6Js.Preload.CSSLoader,
	  ImageLoader: _createEs6Js.Preload.ImageLoader,
	  JavaScriptLoader: _createEs6Js.Preload.JavaScriptLoader,
	  JSONLoader: _createEs6Js.Preload.JSONLoader,
	  JSONPLoader: _createEs6Js.Preload.JSONPLoader,
	  ManifestLoader: _createEs6Js.Preload.ManifestLoader,
	  SoundLoader: _createEs6Js.Preload.SoundLoader,
	  SpriteSheetLoader: _createEs6Js.Preload.SpriteSheetLoader,
	  SVGLoader: _createEs6Js.Preload.SVGLoader,
	  TextLoader: _createEs6Js.Preload.TextLoader,
	  VideoLoader: _createEs6Js.Preload.VideoLoader,
	  XMLLoader: _createEs6Js.Preload.XMLLoader,
	  AbstractRequest: _createEs6Js.Preload.AbstractRequest,
	  MediaTagRequest: _createEs6Js.Preload.MediaTagRequest,
	  TagRequest: _createEs6Js.Preload.TagRequest,
	  XHRRequest: _createEs6Js.Preload.XHRRequest,
	  SamplePlugin: _createEs6Js.Preload.SamplePlugin,
	  LoadItem: _createEs6Js.Preload.LoadItem,
	  LoadQueue: _createEs6Js.Preload.LoadQueue,
	  Methods: _createEs6Js.Preload.Methods,
	  Types: _createEs6Js.Preload.Types,
	  PreloaderElement: _PreloaderElement2.default
	};
	
	exports.default = preload;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createEs6Js = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SoundElement = function () {
	  function SoundElement(props) {
	    _classCallCheck(this, SoundElement);
	
	    this.defaults = {
	      interrupt: _createEs6Js.Sound.Sound.INTERRUPT_ANY,
	      loop: 0,
	      delay: 0,
	      offset: 0,
	      volume: 1,
	      pan: 0
	    };
	    this.props = props;
	    this.playSound();
	  }
	
	  _createClass(SoundElement, [{
	    key: 'playSound',
	    value: function playSound() {
	      var _this = this;
	
	      var filteredProps = Object.assign({}, this.props);
	      delete filteredProps.sound;
	      delete filteredProps.fadeIn;
	      delete filteredProps.fadeOut;
	      delete filteredProps.events;
	      var soundProps = Object.assign({}, this.defaults, filteredProps);
	
	      if (Object.isObject(this.props.fade) && (this.props.fade.type === 'FADE_IN' || this.props.fade.type === 'FADE_ALL')) {
	        soundProps.volume = 0;
	      }
	
	      this.instance = _createEs6Js.Sound.Sound.play(this.props.sound, soundProps);
	
	      var eventsDefined = !!this.props.events;
	
	      if (eventsDefined) {
	        this.props.events.each(function (value, key) {
	          if (Function.isFunction(value)) {
	            _this.instance.on(key, value);
	          }
	        });
	      }
	
	      return this.instance;
	    }
	  }]);
	
	  return SoundElement;
	}();
	
	exports.default = SoundElement;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEs6Js = __webpack_require__(1);
	
	var _SoundElement = __webpack_require__(23);
	
	var _SoundElement2 = _interopRequireDefault(_SoundElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sound = {
	  AbstractSoundInstance: _createEs6Js.Sound.AbstractSoundInstance,
	  CordovaAudioSoundInstance: _createEs6Js.Sound.CordovaAudioSoundInstance,
	  DefaultSoundInstance: _createEs6Js.Sound.DefaultSoundInstance,
	  FlashAudioSoundInstance: _createEs6Js.Sound.FlashAudioSoundInstance,
	  HTMLAudioSoundInstance: _createEs6Js.Sound.HTMLAudioSoundInstance,
	  WebAudioSoundInstance: _createEs6Js.Sound.WebAudioSoundInstance,
	  AbstractPlugin: _createEs6Js.Sound.AbstractPlugin,
	  CordovaAudioPlugin: _createEs6Js.Sound.CordovaAudioPlugin,
	  FlashAudioPlugin: _createEs6Js.Sound.FlashAudioPlugin,
	  HTMLAudioPlugin: _createEs6Js.Sound.HTMLAudioPlugin,
	  WebAudioPlugin: _createEs6Js.Sound.WebAudioPlugin,
	  AudioSprite: _createEs6Js.Sound.AudioSprite,
	  PlayPropsConfig: _createEs6Js.Sound.PlayPropsConfig,
	  Sound: _createEs6Js.Sound.Sound,
	  SoundElement: _SoundElement2.default
	};
	
	exports.default = sound;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// evolve.js